import React from 'react';
import { Phone } from 'lucide-react';

const FloatingCallButton = () => {
  return (
    <a
      href="tel:0644505026"
      className="fixed bottom-6 left-6 z-50 w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 md:hidden animate-pulse"
      aria-label="Call Now"
    >
      <Phone className="w-8 h-8" />
    </a>
  );
};

export default FloatingCallButton;
